import {Decoder, equal, field, object, oneOf} from 'json-bouncer'
import {
    InquiryCommentWithUsers,
    inquiryCommentWithUsersDecoder
} from './InquiryCommentWithUsers'
import {
    InquiryStatusChangeWithUsers,
    inquiryStatusChangeWithUsersDecoder
} from './InquiryStatusChangeWithUsers'
import {BpsUser} from './BpsUser'
import {Cis2User} from './Cis2User'

export type InquiryHistoryEntryWithUsers =
    Comment
    | StatusChange

export interface CommentedStatusChange {
    readonly type: 'CommentedStatusChange'
    readonly comment: InquiryCommentWithUsers
    readonly statusChange: InquiryStatusChangeWithUsers
}

export interface Comment {
    readonly type: 'Comment'
    readonly comment: InquiryCommentWithUsers
}

export function commentDecoder(): Decoder<Comment> {
    const comment: 'Comment' = 'Comment'
    return object({
        type: field('type', equal(comment)),
        comment: field('comment', inquiryCommentWithUsersDecoder()),
    })
}

export interface StatusChange {
    readonly type: 'StatusChange'
    readonly statusChange: InquiryStatusChangeWithUsers
}

export function statusChangeDecoder(): Decoder<StatusChange> {
    const statusChange: 'StatusChange' = 'StatusChange'
    return object({
        type: field('type', equal(statusChange)),
        statusChange: field('statusChange', inquiryStatusChangeWithUsersDecoder()),
    })
}

export function inquiryHistoryEntryWithUsersDecoder(): Decoder<InquiryHistoryEntryWithUsers> {
    return oneOf<InquiryHistoryEntryWithUsers>([
        commentDecoder(),
        statusChangeDecoder(),
    ])
}

export function userDisplayName({bpsUser, cis2User}: {
    bpsUser: BpsUser | null,
    cis2User: Cis2User | null,
}): string {
    if (bpsUser !== null) {
        return `${bpsUser.firstName} ${bpsUser.lastName}`
    } else if (cis2User !== null) {
        return `${cis2User.firstName} ${cis2User.lastName}`
    } else {
        return 'Unbekannt'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryHistoryEntryWithUsers.ts